import { withMountBase } from './mountBase'

export function buildWorkspacePreviewUrl(
  appUrl: string | null,
  appName: string | null | undefined,
  activeSession: string | null | undefined,
  currentPathname?: string,
): string | undefined {
  if (!appUrl) return undefined
  if (!appName) return appUrl

  const targetPath = activeSession && activeSession !== 'main'
    ? `/a/branch/${activeSession}/${appName}/`
    : `/a/dev/${appName}/`

  try {
    const parsed = new URL(appUrl)
    parsed.pathname = withMountBase(targetPath, currentPathname)
    parsed.search = ''
    parsed.hash = ''
    return parsed.toString()
  } catch {
    return appUrl
  }
}
